import React, { createContext, useContext, useState, useEffect } from "react";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showToast = (message, type = "success") => {
    setToast({ message, type });
  };

  useEffect(() => {
    if (!toast) return;
    const timeoutTime = toast.type === "error" ? 3000 : 2000;
    if (toast.type === "success" || toast.type === "info" || toast.type === "error") {
      const timeout = setTimeout(() => setToast(null), timeoutTime);
      return () => clearTimeout(timeout);
    }
  }, [toast]);

  const clearToast = () => setToast(null);

  return (
    <ToastContext.Provider value={{ toast, showToast, clearToast }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
